"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithFlag = WithFlag;
const react_1 = __importDefault(require("react"));
const use_flags_context_hook_1 = require("../hooks/use-flags-context.hook");
const utils_1 = require("../utils");
function WithFlag({ children, flagName, renderOff = () => null, renderOn = () => null, variant, }) {
    const context = (0, use_flags_context_hook_1.useFlagsContext)();
    const flag = context?.flags[flagName] || (0, utils_1.fallbackFlag)(flagName);
    if (variant) {
        context?.onFlagRender(flag, flag.variant.name);
        if (flag.variant.enabled)
            return react_1.default.createElement(react_1.default.Fragment, null, children ? children : renderOn(flag.variant));
        return react_1.default.createElement(react_1.default.Fragment, null, renderOff(flag.variant));
    }
    context?.onFlagRender(flag);
    if (flag.enabled)
        return react_1.default.createElement(react_1.default.Fragment, null, children ? children : renderOn());
    return react_1.default.createElement(react_1.default.Fragment, null, renderOff());
}
//# sourceMappingURL=with-flag.component.js.map